<template>
  <v-dialog v-model="dialog" max-width="620" persistent>
    <v-card>
      <v-card-title class="color-a">
        Publicera möte: "{{ meeting.name }}"
      </v-card-title>
      <v-card-text>
        <p>
          I samband med att du publicerar detta möte, godtar du att vi i
          efterhand debiterar den på mötet angivna betalmetod enligt vår
          prislista. Prislistan finns på https://percap.se och anger kostnad per
          rösträtt registrerad i mötet. Debitering kommer ske 24h efter
          tidpunkten då mötet öppats.
        </p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close">Avbryt</v-btn>
        <v-btn text color="primary" type="submit" @click="approve"
          >Publicera möte</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    meeting: Object
  },
  data() {
    return {
      dialog: false
    };
  },
  mounted() {
    this.$root.$on("approvePublish", () => {
      this.dialog = true;
    });
  },
  methods: {
    close() {
      this.dialog = false;
    },
    async approve() {
      this.$store.dispatch("meetings/publishMeeting", this.meeting.id);
      this.close();
    }
  }
};
</script>

<style></style>
